var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Contact = require('./layout/contact.jsx');
var ContentList = require('./layout/contentList.jsx');

var Faqs = createReactClass({

    componentDidMount: function(){
        this.props.fetchContentListIfNeeded();
        if(Foundation.MediaQuery.atLeast('large')){
            new Foundation.Sticky($('[data-sticky]'), {marginTop: 5.25, stickyOn: 'large', checkEvery: 0});
        }
    },

    render: function(){
        return (
            <div className="content">
                <Helmet
                    title="Help Center"
                    meta={[{
                        name: 'description',
                        content: 'Read FAQs or contact MyGiHealth for more information about our digestive health app.'
                    }]}
                />
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row">
                        <div className="column">
                            <h1>Help</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="large-10 large-centered column">
                        <div className="row">
                            <div className="large-5 large-push-7 column">
                                <div className="contact-us-wrap">
                                    <div data-sticky-container>
                                        <div data-sticky data-anchor="content-list-wrap-inner">
                                            <Contact sendContact={this.props.sendContact} error={this.props.contact.error} clearContactError={this.props.clearContactError} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="large-7 large-pull-5 column">
                                <div className="content-list-wrap">
                                    <div id="content-list-wrap-inner">
                                        <h2>Frequently Asked Questions</h2>
                                        {this.props.contentList.data && this.props.contentList.data.length > 0 &&
                                            <ContentList contentList={this.props.contentList.data} />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = Faqs;



// WEBPACK FOOTER //
// ./src/common/routes/faqs/components/faqs.jsx